<template>
  <div v-if='loading'>
    <oil-cap
        title='ПЛАТЕЖИ'
        :buttons="[
                     {name:'Добавить платеж',route:'payment'},
                 ]"
        :search-filter='onSearchValueChange'
        service-name="payment"
    />
    <v-divider class='my-2'/>
    <oil-table
        :hide-footer="true"
        :keys="[
                     {value:'PaymentDate',text:'Дата'},
                     {value:'CompanyName',text:'Покупатель'},
                     {value:'ContractNumber',text:'Договор'},
                     {value:'Number',text:'Номер / Комментарий'},
                     {value:'PaymentAmount',text:'сумма Оплаты'},
                     {value:'Id',text:''},
                     {value:'DeleteId',text:''},
                 ]"
        :items='payments'
        :paginate='count'
        :item-counts="payments.length +1"
        @paginateAction='paginate'
        :color='color'
    >
      <template v-slot:Id='{value}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-bind='attrs'
                   v-on='on' icon
                   @click='handleRowClick(value)'>
              <v-icon color='primary'>
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>РЕДАКТИ́РОВАТЬ</span>
        </v-tooltip>
      </template>

      <template v-slot:DeleteId='{value}'>
        <v-row>
          <v-col
              md='6'
              offset-md='3'
          >
            <oil-modal
                :value='value'
                tooltipMessage='УДАЛИТЬ'
                mdiIcon='mdi-delete'
                :accept='deletePayment'
            />
          </v-col>
        </v-row>
      </template>

    </oil-table>
  </div>
</template>

<script>
import {paymentService} from '@/services/PaymentService'
import {waybillService} from '@/services/WayBillService'
import {actService} from '@/services/actService'
import {coreApi} from '~/services/core'

export default {
  data: () => ({
    payments: [],
    count: {
      count: 0
    },
    loading: false


  }),
  async created() {
    const ttns = await waybillService.getAll()
    const ttn = ttns.data?.map(({Number, Contract}) => {
      return {
        Number, Contract
      }
    })
    await this.paginate((this.currentPage - 1) * 10)
    this.loading = true
  },
  components: {
    OilTable: () => import('@/components/helper/oil.table'),
    OilCap: () => import('@/components/helper/oil.cap'),
    OilModal: () => import('@/components/helper/form/oil.delete.modal')
  },
  methods: {
    handleRowClick(id) {
      this.$router.push(`payment/${id}`)
    },
    async deletePayment(id) {
      const isDelete = await paymentService.delete(id)
      if (isDelete) {
        const payment = this.payments.find(({Id}) => Id === id)
        const index = this.payments.indexOf(payment)
        this.payments.splice(index, 1)
        this.$notify({
          group: 'mgs',
          type: 'success',
          title: `ПЛАТЕЖИ под номером ${payment.Number} удачно удален`
        })
      }
    },
    async paginate(page) {
      const payments = await paymentService.paginate(page)
      const {count, dates} = payments.data
      this.count.count = count
      this.payments = dates?.map(payment => {
        return {
          Id: payment?.Id,
          DeleteId: payment?.Id,
          PaymentDate: payment?.PaymentDate,
          PaymentAmount: this.regular(payment?.PaymentAmount),
          CompanyName: payment.Buyer?.CompanyName,
          ContractNumber: payment?.Contract?.Number,
          TaxNo: payment?.Buyer?.TaxNo,
          Number: payment?.Number || payment?.Comment,
          Balance: payment?.Contract?.Balance
        }
      }) || []
    },
    async onSearchValueChange(data) {
      if (!data) {
        await this.paginate((this.currentPage - 1) * 10)
        return
      }
      this.payments = data?.map(payment => {
        return {
          Id: payment?.Id,
          DeleteId: payment?.Id,
          PaymentDate: payment?.PaymentDate,
          PaymentAmount: this.regular(payment?.PaymentAmount),
          CompanyName: payment.Buyer?.CompanyName,
          ContractNumber: payment?.Contract?.Number,
          TaxNo: payment?.Buyer?.TaxNo,
          Number: payment?.Number || payment?.Comment,
          Balance: payment?.Contract?.Balance
        }
      })
    },
    color: (item) => !item ? null : (item.Balance < 0 ? 'red-color' : null)
  }
}
</script>
